// Grid-first collection page helpers (sections/ab-gridfirst-cards.liquid).
// Card names and bead sizes are rendered server-side now (snippets/card-title.liquid,
// Theme settings > Product card > Title), so this file no longer rewrites cards.
// What is left:
//  - keepView: when a template is previewed with ?view=..., keep it through filtering.
//  - decorate: on a preview theme, keep product links on the same preview theme.

const previewThemeId = () => {
  const requested = new URL(location.href).searchParams.get('preview_theme_id');
  const theme = window.Shopify?.theme;
  return theme?.role === 'unpublished' ? String(theme.id) : requested;
};

const decorate = link => {
  const id = previewThemeId();
  if (!id) return;
  const url = new URL(link.getAttribute('href'), location.origin);
  if (url.origin !== location.origin) return;
  url.searchParams.set('preview_theme_id', id);
  link.setAttribute('href', url.pathname + url.search + url.hash);
};

const keepView = () => {
  const view = new URLSearchParams(location.search).get('view');
  if (!view) return;
  document.querySelectorAll('form.facets, form[action*="/collections/"]').forEach(form => {
    if (form.querySelector('input[name="view"]')) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'view';
    input.value = view;
    form.appendChild(input);
  });
};

const apply = () => {
  keepView();
  if (!previewThemeId()) return;
  document.querySelectorAll('[data-abgf-design] .product-list product-card a[href]').forEach(decorate);
};

const observedSections = new WeakSet();

const boot = () => {
  if (!document.querySelector('[data-abgf-design]')) return;
  apply();
  document.querySelectorAll('[data-abgf-design]').forEach(region => {
    const section = region.closest('.shopify-section');
    if (!section || observedSections.has(section)) return;
    observedSections.add(section);
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(apply, 80);
    }).observe(section, { childList: true, subtree: true });
  });
};

if (typeof document !== 'undefined') {
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}
